// The MASTER's Creep Type as a labelled select (Aaron 2026-10-07, ruling 7) — for a
// Formik form whose `name` field holds the inspection's / directive's creep_type.
//
// Since version-24 the master's value is the DEFAULT its limitations inherit:
// a limitation left on "Inherit" follows a change here, and one set by hand keeps
// its own (app/inspections/creep.py). Labels are the shared vocabulary
// (src/utils/creepTypes.ts). 6 (Progressive) is never offered, but a stored 6 — or
// any value outside the six — is kept as its own option, so opening the form never
// silently re-sets it.
import React from "react";
import { MenuItem } from "@mui/material";
import { Field, useField } from "formik";
import { TextField } from "formik-mui";
import { CREEP_TYPE_LABELS, creepTypeLabel } from "../utils/creepTypes";

interface Props {
  name?: string;
  label?: string;
  helperText?: string;
  required?: boolean;
}

export const CREEP_TYPE_DEFAULT_HELPER = "Default creep for this inspection's limitations";

export default function CreepTypeField({
  name = "creep_type",
  label = "Creep Type",
  helperText = CREEP_TYPE_DEFAULT_HELPER,
  required = false,
}: Props) {
  const [field] = useField(name);
  const current = field.value === "" || field.value === null || field.value === undefined ? null : Number(field.value);
  const options = Object.entries(CREEP_TYPE_LABELS).map(([value, text]) => ({ value: Number(value), text }));
  if (current !== null && !Number.isNaN(current) && !(current in CREEP_TYPE_LABELS)) {
    options.push({ value: current, text: creepTypeLabel(current) });
  }
  return (
    <Field
      component={TextField}
      select
      fullWidth
      required={required}
      name={name}
      label={label}
      helperText={helperText}
      inputProps={{ "data-testid": `${name}-select` }}
    >
      {options.map((o) => (
        <MenuItem key={o.value} value={o.value}>
          {o.text}
        </MenuItem>
      ))}
    </Field>
  );
}
